<template>
    <div class="queryBox">
        <!-- #页面操作按钮-->
        <!-- <Affix :offset-top="90">
            <Card class="affix-card-head">
                <div slot="title">
                    <div>
                        <Button type="primary" icon="md-close">关闭</Button>
                        <Button class="ivu-ml-8" icon="ios-copy" type="primary" v-ab-btn-rights:supplier_select_btn
                            @click="search()">
                            临时保存
                        </Button>
                    </div>
                    <div>
                        <Button to="/hrm/Certificateofapproval" type="primary" icon="md-arrow-up"
                            style="margin-left: 10px">申请</Button>
                    </div>
                </div>
            </Card>
        </Affix> -->
        <card padding="5">
            <Form ref="searchForm" class="searchForm" label-width="110" label-position="right">
                <div class="searchForm-div">
                    <h1>证书审批</h1>
                </div>
                <div class="ivu-card-head">
                    <ul slot="title" v-show="task">
                        <li>[单据编号：<span>CA-申请系统名称-日期-001]</span>
                        </li>
                        <li>用户id：<span>admin</span></li>
                        <li>用户姓名：<span>XZHSKOMTRAX_吴秀娟</span></li>
                        <li>公司邮箱：<span>123456789@qq.com</span></li>
                    </ul>
                </div>
                <Row :gutter="24" type="flex" justify="center" align="middle" class="row">
                    <Col span="24" offset="0" class="row-col">
                    <table class="i-iview-table form-table from-ta" border="0">
                        <tbody>
                            <tr>
                                <td>系统分类</td>
                                <td>
                                    KOMTRAX
                                </td>
                                <td>
                                    供应商/公司
                                </td>
                                <td>
                                    XZHS
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </Col>
                </Row>
                <Row :gutter="24" type="flex" justify="center" align="middle" class="Row"
                    v-for="(item,index) in data.certificateapplication.zssqList" :key="index">
                    <Col span="24" offset="0">
                    <table class="i-iview-table form-table from-ta" border="0">
                        <tbody>
                            <tr>
                                <td>申请人姓名</td>
                                <td>
                                    {{item.NameUser}}
                                </td>
                                <td>
                                    公司邮箱
                                </td>
                                <td>
                                    {{item.applicationemail}}
                                </td>
                                <td>
                                    证书申请编号
                                </td>
                                <td>
                                    {{item.applySerial}}
                                </td>
                                <td>制作日期</td>
                                <td>
                                    {{item.Productiondate}}
                                </td>
                                <td>
                                    证书有效期
                                </td>
                                <td>
                                    {{item.effective}}
                                </td>
                                <td>
                                    证书数量
                                </td>
                                <td>
                                    {{item.number}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </Col>
                </Row>
                <Row style="margin-top:10px;">

                    <!-- 添加附件-->
                    <Col :xs="24" :sm="24" :md="12" :lg="24" class="col">
                    <FormItem label="申请理由">
                        <Input type="textarea" disabled placeholder="请在申请第二张证书的时候务必填写理由。"></Input>
                    </FormItem>
                    <FormItem label="添加附件">
                        <Upload multiple type="drag" action="//jsonplaceholder.typicode.com/posts/">
                            <div style="width:100% !important;">
                                <Icon type="ios-cloud-upload" size="42" style="color: #3399ff"></Icon>
                            </div>
                        </Upload>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
        </card>
    </div>
</template>

<script>
    export default {
        name: "certificateapplication",
        data() {
            return {
                departmentDate: {
                    code_: ""
                },
                hide: false,
                sing: false,
                singles: false,
                tree_show: false,
                date: "",
                single: true,
                list: [{
                    model1: 'XZHSKOMTRAX_吴秀娟',
                    model2: '123456789@qq.com',
                    model4: '21KomtraxHigher00330',
                    model5: '',
                    model6: 'C0004',
                    model7: 'y21',
                    model9: '首张',
                    model10: '2021/12/31',
                    model11: '2021/12/31',
                    model12: '365天',
                }],
                //系统分类
                sex: [{
                        value: "KWING",
                        label: "KWING",
                    },
                    {
                        value: "KOMTRAX",
                        label: "KOMTRAX",
                    },
                ],
                //年份
                year: [{
                        value: "y21",
                        label: "y21",
                    },
                    {
                        value: "y22",
                        label: "y22",
                    },
                ],
                //等级
                Education: [{
                        value: "H",
                        label: "H",
                    },
                    {
                        value: "L",
                        label: "L",
                    }
                ],
                //在职状态
                zaizhiStatus: [{
                        value: "在职",
                        label: "在职",
                    },
                    {
                        value: "离职",
                        label: "离职",
                    },
                    {
                        value: "停薪留职",
                        label: "停薪留职",
                    },
                ],

                ICT: [{
                        value: "365天",
                        label: "365天",
                    },
                    {
                        value: "90天",
                        label: "90天",
                    },
                    {
                        value: "30天",
                        label: "30天",
                    },
                ],
                num: [{
                        value: "首张",
                        label: "首张",
                    },
                    {
                        value: "第一张",
                        label: "第一张",
                    },
                    {
                        value: "第二张",
                        label: "第二张",
                    },
                ],
                //系统分类
                agent: [{
                        value: "KOMTRAX",
                        label: "KOMTRAX",
                    },
                    {
                        value: "XZHS",
                        label: "XZHS",
                    },
                    {
                        value: "KJX",
                        label: "KJX",
                    },
                ],
                factorial: 'KOMTRAX',
                task: false,
                data: {
                    certificateapplication: {
                        zssqList: []
                    }
                },
            };
        },
        methods: {
            keep() {
                this.$parent.data = this.data;
                this.$parent.data.certificateapplication.zssqList = this.data.certificateapplication.zssqList
            },
            //部门清空
            remove(index) {
                this.list[index].model1 = ""
                console.log(list);
            },
            //组织树选择部门后取值
            pushOrgRelationList(dataArr, index) {
                console.log(dataArr);
                this.list[index].model1 = dataArr[0].fullname;
            },
        },
        mounted: function () {
            // this.$parent.task 存在 代表是审批画面，不存在是申请画面
            if (!this.task && this.$parent.task) {
                this.task = true;
            } else if (this.$parent.instance) {
                this.task = true;
            }
            this.data = this.$parent.data;
            for (let i = 0; i < this.data.certificateapplication.zssqList.length; i++) {
                console.log(i, this.data.certificateapplication.zssqList);
            }
        },
    };
</script>
<style lang="less" scoped>
    .col {
        .ivu-form-item {
            margin-left: -30px;

        }

        /deep/.ivu-input {
            height: 70px !important;
            text-align: left;
        }
    }

    .searchForm {
        margin-bottom: 5px;
        border: 1px solid #e5e5e5;

        .searchForm-div {
            padding: 10px;
            display: flex;
            justify-content: center;
        }
    }

    .row {
        margin-bottom: 5px;
        margin-left: 0px !important;
        margin-right: 0px !important;

        .row-col {
            padding-left: 0px !important;
            padding-right: 0px !important;

            .from-ta {
                width: 100%;

                td:nth-child(1) {
                    background-color: #ebf7ff;
                    width: 20%;
                }

                td:nth-child(2) {
                    width: 30%;

                    .ivu-select-default {
                        width: 100%;
                    }
                }

                td:nth-child(3) {
                    background-color: #ebf7ff;
                    width: 20%;
                }

                td:nth-child(4) {
                    width: 30%;
                }
            }
        }
    }

    .Row {
        margin: 10px;

        .from-ta {
            width: 100%;

            td:nth-child(2n-1) {
                background-color: #ebf7ff
            }

            td:nth-child(1),
            td:nth-child(9) {
                width: 7%;
            }

            td:nth-child(2),
            td:nth-child(4),
            td:nth-child(6),
            td:nth-child(8) {
                width: 12.5%;
            }

            td:nth-child(10) {
                width: 7%;
            }

            td:nth-child(12) {
                width: 4%;
            }

            td:nth-child(5){
                width: 7%;
            }

            td:nth-child(3),
            td:nth-child(7),
            td:nth-child(11) {
                width: 6%;
            }
        }
    }

    .ivu-card-head {
        background: #2d8cf0;
        margin-top: 5px;

        ul {
            display: flex;
            align-items: center;

            span {
                margin-left: 5px;
                color: #fff;
            }

            li:nth-child(1) {
                margin-left: 10px !important;
                color: #fff;
            }

            li {
                margin-left: 20px;
                color: #fff;
            }
        }
    }

    .ivu-upload {
        width: 100%;
    }

    /deep/.ivu-input {
        text-align: center;
    }

    .from-ta td {
        padding: 1px;
    }

    /deep/.padding>.ivu-card-body {
        padding: 20px 10px 15px 10px !important;
    }

    .border {
        border: 1px solid rgb(219, 219, 219);
        border-radius: 10px 10px 0px 0px;
        height: 40px;
        display: flex;
        align-content: center;

        p {
            margin-left: 10px;
            margin-top: 10px;
        }
    }
</style>
